import { getPrivateApi } from '../../../../services/api';
import { purge } from '@vy/utils';
import { useQuery } from 'react-query';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';
import { QuickBooksGetCustomersResponse, QuickBooksGetCustomersResponseSchema } from '@vy/api-definition';
import { useQuickbooksEnabled } from './use-quickbooks-enabled';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useQuickBooksCustomers(
  searchParam?: string,
  options?: CustomUseQueryOptions<QuickBooksGetCustomersResponse>,
) {
  const isQuickBooksActivated = useQuickbooksEnabled();

  const queryDeps = purge([searchParam]);

  return useQuery(
    queryKeys.quickbooksCustomers(...queryDeps),
    async () => {
      const api = getPrivateApi();
      const response = await api.quickbooksGetCustomers({ search: searchParam });

      return QuickBooksGetCustomersResponseSchema.parse(response);
    },
    {
      ...options,
      enabled: isQuickBooksActivated,
    },
  );
}
